export default 'bankId';
